export default "__VITE_ASSET__CBQ7s27X__"